import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';

import { setupAuthKey, hasAuthKey } from 'utils/api/auth-utils';
import { isAnyAdmin, isUserClient } from 'selectors/user/user-roles-selector';
import Icon from 'components/icon';
import styles from 'pages/report/sections/section.module.css';

const AuthTokenWrapper = ({ children }) => {
    const location = useLocation();
    const searchParams = new URLSearchParams(location.search);

    const token = searchParams.get('token');

    const [isProcessing, setProcessing] = useState(true);
    const [errorContent, setError] = useState(null);

    const isClient = useSelector(isUserClient);
    const isAdmin = useSelector(isAnyAdmin);

    useEffect(() => {
        if (isClient || isAdmin) {
            setProcessing(false);

            return;
        }

        if (hasAuthKey()) {
            setProcessing(false);

            return;
        }

        if (!token) {
            setError('Need token');

            return;
        }

        setupAuthKey(token);
        setError(null);
        setProcessing(false);

        return () => {
            setProcessing(true);
            setError(null);
        };
    }, [token, isClient, isAdmin]);

    if (!!errorContent) {
        return <>{errorContent}</>;
    }

    if (isProcessing) {
        return (
            <div className={styles.loading}>
                <Icon type="spinner" pulse wrapped={false} size={5} />
            </div>
        );
    }

    return <>{children}</>;
};

export default AuthTokenWrapper;
